import React from "react";
import ReactEcharts from "echarts-for-react";

function BarData(props) {
  const { data } = props;
  console.log(data);
  const getOptions = () => {
    return {
      grid: {
        left: 20, // 左边距20px
        right: 20, // 右边距20px
        bottom: 20,
        top: 60,
        containLabel: true,
      },
      xAxis: {
        type: "category",
        data: [2023, 2024, 2025, 2026],
      },
      yAxis: {
        type: "value",
      },
      legend: { data: ["男", "女"], top: 10 },
      series: [
        {
          name: "男",
          data: [1200, 1400, 1300, 1500],
          type: "bar",
          barWidth: 10, // 柱子宽度（占类目宽度的比例，可选）
          itemStyle: {
            color: "#409eff", // 柱子颜色（蓝色，醒目）
            borderRadius: [4, 4, 0, 0], // 柱子顶部圆角，更美观
          },
        },
        {
          name: "女",
          data: [1000, 1150, 1107, 1301],
          type: "bar",
          barWidth: 10, // 柱子宽度（占类目宽度的比例，可选）
          itemStyle: {
            color: "rgb(64, 204, 255)", // 柱子颜色（蓝色，醒目）
            borderRadius: [4, 4, 0, 0], // 柱子顶部圆角，更美观
          },
        },
      ],
    };
  };
  return (
    <>
      <ReactEcharts
        style={{
          minHeight: "300px",
          width: "100%",
        }}
        option={getOptions()}
      />
    </>
  );
}

export default BarData;
